/*
 * Bundle picker (design 2a).
 *
 * State is deliberately tiny: a size, a tier index, and an ordered list of
 * colour names. Everything on screen is derived from those three, so there is
 * no second source of truth to drift.
 *
 *   size  : string
 *   tier  : 0 | 1 | 2
 *   picks : string[]   ordered colour names, length <= tier.items
 *
 * Free items are positional: the first `paid` picks are charged, the rest are
 * free. With every colour at the same price that is equivalent to "cheapest
 * free", and it keeps the chip labels predictable.
 */
(function () {
  var root = document.querySelector('[data-bundle-picker]');
  if (!root) return;

  var dataEl = root.querySelector('[data-bp-variants]');
  var DATA = {};
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var VARIANTS = DATA.variants || {};
  var FITS = DATA.fits || null;
  var FITS_LABEL = DATA.fitsLabel || '';

  var sizeBtns = [].slice.call(root.querySelectorAll('[data-bp-size]'));
  var tierBtns = [].slice.call(root.querySelectorAll('[data-bp-tier]'));
  var swatches = [].slice.call(root.querySelectorAll('[data-bp-color]'));
  var chipsEl = root.querySelector('[data-bp-chips]');
  var pickedEl = root.querySelector('[data-bp-picked]');
  var progressEl = root.querySelector('[data-bp-progress]');
  var sizeLabel = root.querySelector('[data-bp-size-label]');
  var fitsEl = root.querySelector('[data-bp-fits]');
  var giftEl = root.querySelector('[data-bp-gift]');
  var oosEl = root.querySelector('[data-bp-oos]');
  var cta = root.querySelector('[data-bp-cta]');

  /*
   * The add-to-cart form lives on document.body, never inside this snippet.
   *
   * main-product renders every block inside `{% form 'product' %}`; a form
   * nested in a form is invalid, so the browser drops the inner tag and its
   * inputs silently join the OUTER product form — which carries its own
   * `name="id"` and adds one default variant. That is exactly the wrong-order
   * bug this avoids.
   *
   * Submitting a real form (rather than fetching directly) keeps cart-drawer.js
   * working: it listens for submits on any form[action*="/cart/add"] and opens
   * the drawer for us.
   */
  var addForm = document.createElement('form');
  addForm.action = (window.routes && window.routes.cart_add_url) || '/cart/add';
  addForm.method = 'post';
  addForm.hidden = true;
  document.body.appendChild(addForm);
  var inputsEl = addForm;
  var hintEl = root.querySelector('[data-bp-hint]');

  var state = {
    size: sizeBtns.length ? sizeBtns[0].getAttribute('data-bp-size') : '',
    tier: 1,
    picks: []
  };

  function tier() {
    var b = tierBtns[state.tier];
    return {
      items: parseInt(b.getAttribute('data-items'), 10),
      paid: parseInt(b.getAttribute('data-paid'), 10),
      price: parseInt(b.getAttribute('data-price'), 10),
      priceText: b.getAttribute('data-price-formatted') || '',
      gift: b.getAttribute('data-gift') === 'true',
      label: b.getAttribute('data-label')
    };
  }

  function variantFor(color, size) {
    return VARIANTS[color + '||' + size] || null;
  }

  /* A colour is only offered if it exists in the CURRENTLY selected size —
     otherwise a shopper fills the bundle and discovers at checkout that one
     line is unavailable. */
  function sellable(color) {
    var v = variantFor(color, state.size);
    return !!(v && v.available);
  }

  /*
   * Seed the FIRST colour only.
   *
   * One pick on arrival shows how the picker works — a swatch with a count
   * badge, a chip, a counter that moved — without deciding the rest of the
   * bundle for the shopper. Filling every slot would be answering a question
   * they were never asked.
   *
   * Runs once, and only into an empty bundle, so it can never overwrite or
   * refill after someone starts choosing.
   */
  function seedFirstColour() {
    if (state.picks.length > 0) return;
    for (var i = 0; i < swatches.length; i++) {
      var c = swatches[i].getAttribute('data-bp-color');
      if (sellable(c)) { state.picks.push(c); return; }
    }
  }

  function render() {
    var t = tier();

    sizeBtns.forEach(function (b) {
      var on = b.getAttribute('data-bp-size') === state.size;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    if (sizeLabel) sizeLabel.textContent = state.size;
    if (fitsEl) {
      var f = FITS && FITS[state.size];
      // "[size]" is the merchant's placeholder, not Liquid's — braces inside a
      // Liquid output tag would close it early, so the theme uses brackets.
      var lab = FITS_LABEL ? FITS_LABEL.replace('[size]', state.size) + ' ' : '';
      fitsEl.textContent = f ? lab + f : '';
      fitsEl.hidden = !f;
    }

    tierBtns.forEach(function (b, i) {
      var on = i === state.tier;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    var counts = {};
    state.picks.forEach(function (c) { counts[c] = (counts[c] || 0) + 1; });
    var full = state.picks.length >= t.items;
    var unavailable = [];

    swatches.forEach(function (b) {
      var c = b.getAttribute('data-bp-color');
      var n = counts[c] || 0;
      var badge = b.querySelector('[data-bp-count]');
      if (badge) {
        badge.textContent = n || '';
        badge.hidden = !n;
      }
      b.classList.toggle('is-picked', !!n);

      var ok = sellable(c);
      if (!ok) unavailable.push(c);
      // Disabled when sold out in this size, or when the bundle is already full
      // and this colour is not part of it.
      b.disabled = !ok || (full && !n);
      b.classList.toggle('is-oos', !ok);
      // A picked swatch on a full bundle removes rather than adds — say so.
      b.setAttribute('aria-label', (full && n ? 'Remove ' : 'Add ') + c);
      b.title = !ok ? c + ' (sold out in size ' + state.size + ')'
        : (full && n ? c + ' — tap to remove' : c);
    });

    if (oosEl) {
      if (unavailable.length) {
        oosEl.textContent = unavailable.join(', ') +
          (unavailable.length === 1 ? ' is' : ' are') + ' sold out in size ' + state.size + '.';
        oosEl.hidden = false;
      } else {
        oosEl.hidden = true;
      }
    }

    // Chips: one per pick, then dashed placeholders for what is still missing.
    chipsEl.innerHTML = '';
    state.picks.forEach(function (c, i) {
      var chip = document.createElement('span');
      chip.className = 'bp-chip';
      chip.innerHTML =
        '<span class="bp-chip__dot" data-c></span>' +
        '<span>' + c + (i >= t.paid ? ' · free' : '') + '</span>' +
        '<button type="button" class="bp-chip__x" aria-label="Remove ' + c + '">×</button>';
      var dot = chip.querySelector('[data-c]');
      var src = swatchStyle(c);
      if (src) dot.setAttribute('style', src);
      chip.querySelector('.bp-chip__x').addEventListener('click', function () {
        state.picks.splice(i, 1);
        render();
      });
      chipsEl.appendChild(chip);
    });
    for (var i = state.picks.length; i < t.items; i++) {
      var ph = document.createElement('span');
      ph.className = 'bp-chip bp-chip--empty';
      ph.textContent = i >= t.paid ? 'Free Pick ' + (i - t.paid + 1) : 'Pick ' + (i + 1);
      chipsEl.appendChild(ph);
    }

    pickedEl.textContent = state.picks.length ? state.picks.join(', ') : 'none yet';
    progressEl.textContent = state.picks.length + ' of ' + t.items + ' picked';
    progressEl.classList.toggle('is-done', full);
    if (giftEl) giftEl.hidden = !t.gift;

    var left = t.items - state.picks.length;
    cta.disabled = left > 0;
    cta.textContent = left > 0
      ? 'Pick ' + left + ' more colour' + (left === 1 ? '' : 's')
      /* Formatted by Liquid's `money` filter, never computed here. Doing the
         maths in JS printed the shop's base-currency amount with a hard-coded
         £ sign, so a GBP shopper saw £89.97 where the cart said £69.00. */
      : 'Add to cart  ' + t.priceText;

    /*
     * Terse by design. The hint is an instruction, not a sentence — it is read
     * at a glance while choosing, so every word past the instruction is noise.
     * The one case that must be spelled out is fewer colours than slots, where
     * repeating a colour is the only way to finish.
     */
    var sellableCount = swatches.filter(function (b) {
      return sellable(b.getAttribute('data-bp-color'));
    }).length;

    if (t.items === 1) {
      hintEl.textContent = 'Size ' + state.size + '.';
    } else if (full) {
      hintEl.textContent = 'Tap a colour to change it.';
    } else if (sellableCount > 0 && sellableCount < t.items) {
      hintEl.textContent = 'Only ' + sellableCount + ' colour' + (sellableCount === 1 ? '' : 's') +
        ' in size ' + state.size + '. Tap one again to repeat it.';
    } else {
      hintEl.textContent = 'Tap a colour again to repeat it.';
    }

    writeInputs(t);
  }

  function swatchStyle(color) {
    var btn = swatches.filter(function (b) {
      return b.getAttribute('data-bp-color') === color;
    })[0];
    return btn ? btn.getAttribute('style') : null;
  }

  /*
   * One hidden input group per pick, in the form encoding /cart/add.js expects.
   * Rebuilt from scratch each render so a removed pick cannot leave a stale
   * line behind — the commonest way this kind of builder ships a wrong order.
   */
  function writeInputs(t) {
    addForm.innerHTML = '';
    if (state.picks.length !== t.items) return;

    // Groups every line of one add-to-cart together, so cart logic and a
    // discount function can treat them as a single bundle.
    var bundleId = 'bp-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1e6).toString(36);

    state.picks.forEach(function (color, i) {
      var v = variantFor(color, state.size);
      if (!v) return;
      add('items[' + i + '][id]', v.id);
      add('items[' + i + '][quantity]', 1);
      add('items[' + i + '][properties][_bundle_id]', bundleId);
      add('items[' + i + '][properties][_bundle]', t.label);
      add('items[' + i + '][properties][_bundle_slot]', i + 1);
      add('items[' + i + '][properties][_bundle_free]', i >= t.paid ? 'true' : 'false');
      // Shown to the shopper in the cart, unlike the _prefixed ones above.
      add('items[' + i + '][properties][Colour]', color);
      add('items[' + i + '][properties][Size]', state.size);
    });

    function add(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      addForm.appendChild(input);
    }
  }

  sizeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.size = b.getAttribute('data-bp-size');
      // Picks are kept: a shopper changing their mind on size should not lose
      // the colours they chose. Anything now sold out is flagged by render().
      render();
    });
  });

  tierBtns.forEach(function (b, i) {
    b.addEventListener('click', function () {
      state.tier = i;
      // Truncate rather than clear, so 3-pack -> 5-pack keeps existing picks,
      // then top up the new slots so the bundle stays ready to buy.
      // Truncate rather than clear, so 3-pack -> 5-pack keeps existing picks.
      // Nothing is added: the empty slots are the shopper's to fill.
      state.picks = state.picks.slice(0, tier().items);
      render();
    });
  });

  swatches.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      var color = b.getAttribute('data-bp-color');
      var t = tier();

      /*
       * Tapping a colour adds one, which is how a shopper takes two of the same.
       * Once the bundle is FULL there is nothing left to add, so the same tap
       * becomes "remove one" — otherwise a completed bundle is a dead end and
       * the only way to change your mind is the small × on a chip.
       *
       * Removes the LAST instance, so tapping a colour twice in a row is a
       * clean undo of the tap before it.
       */
      if (state.picks.length >= t.items) {
        var last = state.picks.lastIndexOf(color);
        if (last === -1) return;
        state.picks.splice(last, 1);
      } else {
        state.picks.push(color);
      }
      render();
    });
  });

  cta.addEventListener('click', function () {
    if (cta.disabled || !addForm.children.length) return;
    cta.setAttribute('aria-busy', 'true');
    // requestSubmit fires submit handlers; .submit() would bypass the drawer.
    if (addForm.requestSubmit) {
      addForm.requestSubmit();
    } else {
      addForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
    window.setTimeout(function () { cta.removeAttribute('aria-busy'); }, 1200);
  });

  seedFirstColour();
  render();
})();

/*
 * Kaching suppression.
 *
 * Kaching Bundles renders from an APP EMBED as well as an app block, so
 * removing the block from a template does not remove the widget — the embed
 * injects it client-side, after this page's HTML has already been served. On a
 * product using the picker that leaves two "Bundle & Save" selectors offering
 * the same tiers, which is worse than either alone.
 *
 * Scoped to pages that actually have a picker, so the five products still on
 * Kaching are untouched. If the app is ever disabled or its markup changes,
 * this simply finds nothing and does nothing.
 *
 * The observer is needed because the embed can inject well after DOMContentLoaded.
 */
(function () {
  if (!document.querySelector('[data-bundle-picker]')) return;

  function hide() {
    // Hyphen, not underscore: `.kaching-bundles-product` is the embed's
    // container. CSS already hides it; this is the belt to that braces, for a
    // node injected outside the container the stylesheet knows about.
    var found = document.querySelectorAll('.kaching-bundles-product, .kaching-bundles__block');
    for (var i = 0; i < found.length; i++) {
      var el = found[i];
      if (el.closest('[data-bundle-picker]')) continue;   // never hide our own
      if (el.dataset.bpHidden) continue;
      el.dataset.bpHidden = '1';
      el.style.display = 'none';
    }
  }

  hide();
  if (typeof MutationObserver === 'function') {
    var obs = new MutationObserver(hide);
    obs.observe(document.documentElement, { childList: true, subtree: true });
    // The embed lands within a second or two; watching forever is wasteful.
    window.setTimeout(function () { obs.disconnect(); }, 15000);
  }
})();
